import initialState from 'store/globalState/initialState';

import {
  SHOW_MODAL_INFORMATION,
  HIDE_MODAL_INFORMATION,
  UPDATE_MODAL_INFORMATION_TEXT,
  SHOW_MODAL_TEXT,
  SHOW_MODAL_SWIPE_UP,
  SHOW_MODAL_SWIPE_DOWN,
  SHOW_MODAL_SWIPE_LEFT,
  SHOW_MODAL_SWIPE_RIGHT,
  SHOW_MODAL_SINGLE_PRESS,
  SHOW_MODAL_LONG_PRESS,
  SHOW_MODAL_PRESS_AND_DRAG,
} from './types';

export function modalInformationReducer(state = initialState.modalInformation, action) {
  switch (action.type) {
    case HIDE_MODAL_INFORMATION:
      return initialState.modalInformation;
    case SHOW_MODAL_INFORMATION:
    case UPDATE_MODAL_INFORMATION_TEXT:
    case SHOW_MODAL_TEXT:
    case SHOW_MODAL_SWIPE_UP:
    case SHOW_MODAL_SWIPE_DOWN:
    case SHOW_MODAL_SWIPE_LEFT:
    case SHOW_MODAL_SWIPE_RIGHT:
    case SHOW_MODAL_SINGLE_PRESS:
    case SHOW_MODAL_LONG_PRESS:
    case SHOW_MODAL_PRESS_AND_DRAG:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export default modalInformationReducer;



// WEBPACK FOOTER //
// ./src/components/ModalInformation/modules/index.js